<template>
	<div class="container">
		<div class="handle-container">
			<div class="search-container">
				可拖拽调整位置
			</div>
			<div class="btn-style">
				<Button type="primary" icon="md-add" @click="openSyncModal">同步</Button>
				<Button type="primary" class="import-btn" icon="md-add" @click="addKnowledge">添加问题</Button>
				<Button type="primary" class="import-btn" @click="showImportModal = true">批量导入</Button>
				<Button type="primary" class="import-btn" @click="exportKnowledge">导出</Button>
			</div>
		</div>
		<div class="table-container">
			<Table :columns="columns" :data="knowledge" draggable @on-drag-drop="hagndleDrop"
				@on-selection-change="handleSelectionChange">
				<!-- 回答内容 -->
				<template slot-scope="{ row }" slot="sentences">
					<div class="keywordCon">
						{{row.sentences.map(item => item.replace(/;/g, '\\;')).join(';')}}
					</div>
				</template>
				<template slot-scope="{ row }" slot="content">
					<div v-for="response in (row.responses || [])" :key="response.id" style="display: flex">
						<audio-play :filepath="response.voice" />
						{{ response.text }}
					</div>
				</template>
				<template slot-scope="{ row }" slot="totalHit">
					<span>{{ knowledgeHitStat(row.name) ? knowledgeHitStat(row.name).totalHit : '-' }}</span>
				</template>
				<template slot-scope="{ row }" slot="percent">
					<span class="hit-percent" v-if="knowledgeHitStat(row.name)">{{ knowledgeHitStat(row.name).percent }}%</span>
					<span v-else>-</span>
				</template>
				<template slot-scope="{ row }" slot="action">
					<span class="edit-style" @click='handleEdit(row)'>编辑</span>
					<Poptip confirm title="确认要删除这条数据吗？" @on-ok="delKnowledge(row.id)" transfer>
						<span class="del-style">删除</span>
					</Poptip>
				</template>
			</Table>
		</div>
		<knowledge-modal v-model="showKnowledgeModal" @onSubmit="editKnowledge" @cancel="curKnowledge = undefined"
			:curKnowledge="curKnowledge" />
		<import-modal v-model="showImportModal" />
		<sync-modal v-model="showSyncModal" @onSubmit="handleSync" />
	</div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { getSceneDetailA, editSceneA, addSceneIntentA } from '@/server/api'
import AudioPlay from '../../components/AudioPlay.vue'
import ImportModal from './components/importModal.vue'
import KnowledgeModal from './components/knowledgeModal.vue'
import XLSX from 'xlsx'
import SyncModal from '@/components/SyncModal.vue';
import cloneDeep from 'lodash/cloneDeep'

export default {
	components: {
		KnowledgeModal,
		ImportModal,
		AudioPlay,
		SyncModal,
	},
	data() {
		return {
			showSyncModal: false,
			showKnowledgeModal: false,  // 编辑弹窗显示
			curKnowledge: undefined, // 编辑时的数据
			showImportModal: false,
			columns: [
				{
					type: 'selection',
					width: 60,
					align: 'center'
				},
				{ title: '序号', key: 'name', width: '120' },
				{ title: '标题', key: 'name', width: '120' },
				{ title: '关键词', slot: 'sentences' },
				{ title: '回答内容', slot: 'content', width: '250' },
				// {title: '录音', key: 'audio'},
				{title: '类型', key: 'type', width: '100'},
				{title: '命中通话数', slot: 'totalHit', width: '120'},
				{title: '命中率', slot: 'percent', width: '100'},
				{title: '操作', slot: 'action', width: '120'},
			],
			selectedKnowledge: [],
		}
	},
	computed: {
		...mapState('knowledge', [
			'knowledge',
		]),
		...mapState('setting', [
			'vars',
    ]),
    ...mapGetters('knowledge', ['knowledgeHitStat']),
	},
	methods: {
		...mapActions('knowledge', ['saveKnowledge', 'delKnowledge', 'modifyPosition']),
		addKnowledge() {
			this.showKnowledgeModal = true
		},
		editKnowledge(knowledge) {
			this.saveKnowledge(knowledge)
		},
		handleEdit(knowledge) {
			this.curKnowledge = knowledge;
			this.showKnowledgeModal = true;
		},
		hagndleDrop(originalP, newP) {
			this.modifyPosition({ originalP, newP })
		},
		// 导出
		exportKnowledge() {
			const columns = [
				{
					dataIndex: 'type', title: '类型', renderText: (text) => {
						return text === 'bussiness' ? '业务问题' : '常规问题'
					}
				},
				{ dataIndex: 'name', title: '标题' },
				{ dataIndex: 'sentences', title: '关键词', renderText: (text) => {
					return text?.map(item => item.replace(/,/g, '\\,')).join(',')
				} },
				{ dataIndex: 'responses', title: '机器人回答文本', renderText: (text) => {
					return text?.map(item => item.text).join('\n')
				}},
			]
			const gaugeOutfit = columns?.map((item) => item.title);
			const list = this.knowledge?.map((item) => {
				return columns?.map((head) =>
					head.renderText ? head.renderText(item[head.dataIndex], item) : item[head.dataIndex],
				);
			});
			list.unshift(gaugeOutfit);
			const worksheet = XLSX.utils.aoa_to_sheet(list);
			const newWorkbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(newWorkbook, worksheet, 'sheet');
			XLSX.writeFile(newWorkbook, '问答知识库.xlsx');
		},
		/**
		 * 同步
		 */

		openSyncModal() {
			this.showSyncModal = true
		},
		async handleSync(syncData, callback) {
			try {
				// 1. 根据获取的意图和同步的内容获取到要同步的数据
				const syncKnowledge = this.getSyncKnowledge(syncData);

				if (syncKnowledge.length === 0) {
					this.$Message.warning('没有可同步的意图数据');
					if (callback) callback();
					return;
				}

				// 2. 循环选择的话术
				const { sceneId, duplicateHandle, keywordHandle, syncContent } = syncData;
				let successCount = 0;
				let failCount = 0;

				for (const targetSceneId of sceneId) {
					try {
						// 3. 根据话术id获取到话术json
						const sceneResponse = await getSceneDetailA({ sceneId: targetSceneId });
						if (sceneResponse.code !== 200) {
							failCount++;
							continue;
						}

						const sceneJsonStr = sceneResponse.data?.sceneJson || '{}';
						const targetSceneName = sceneResponse.data?.sceneName || '';
						let sceneJson;
						try {
							sceneJson = JSON.parse(sceneJsonStr);
						} catch (error) {
							console.error('话术JSON解析失败:', error);
							failCount++;
							continue;
						}

						// 4. 根据重复处理把意图添加到话术json中
						const [updatedKnowledge, settingVars] = this.mergeKnowledge(
							sceneJson,
							syncKnowledge,
							duplicateHandle,
							keywordHandle,
							syncContent,
						);

						// 保存更新后的话术
						const saveResponse = await editSceneA({
							ver: 2,
							sceneId: targetSceneId,
							sceneJson: JSON.stringify({
								...sceneJson,
								id: targetSceneId,
								version: sceneJson.version || '2.2',
								name: targetSceneName || sceneJson.name || '',
								settings: {
									...sceneJson.settings,
									vars: settingVars
								},
								knowledge: updatedKnowledge
							})
						});

						if (saveResponse.code === 200) {
							successCount++;
							// 建立目标场景与意图词库的引用关系
							syncKnowledge.forEach(item => {
								if (item.ref_id && typeof item.ref_id === 'string') {
									addSceneIntentA({
										scene_id: targetSceneId,
										intent_id: item.ref_id,
										scene_name: targetSceneName,
									});
								}
							});
						} else {
							failCount++;
						}
					} catch (error) {
						console.error(`同步话术 ${targetSceneId} 失败:`, error);
						failCount++;
					}
				}

				if (successCount > 0) {
					this.$Message.success(`同步完成：成功 ${successCount} 个，失败 ${failCount} 个`);
				} else {
					this.$Message.error('同步失败，请重试');
				}
				callback()
			} catch (error) {
				console.error('同步过程出错:', error);
				this.$Message.error('同步失败，请重试');
				callback(error)
			}
		},

		// 根据同步内容获取要同步的知识数据
		getSyncKnowledge(syncData) {
			const { syncContent } = syncData;
			const currentKnowledge = cloneDeep(this.selectedKnowledge || []);

			return currentKnowledge.map(knowledge => {
				const { type, name, sentences, ref_id, ...otherParams } = knowledge;
				// 基本信息
				let syncKnowledge = {
					type: type,
					name: name,
				};

				// responses: [{ text: '', voice: '', id: addNodeId('V') }],

				// 关键词
				if (syncContent.includes('2')) {
					syncKnowledge.sentences = sentences || [];
					syncKnowledge.ref_id = ref_id;
					syncKnowledge.is_ref_priority = true;
				}

				// 其他设置 
				if (syncContent.includes('3')) {
					syncKnowledge = {
						...syncKnowledge,
						...otherParams,
						conditions: knowledge.conditions || [],
						responses: knowledge.responses || [],
						action: knowledge.action || '',
						action_data: knowledge.action_data || '',
						tag: knowledge.tag || '',
						can_break: knowledge.can_break || false,
						break_delay: knowledge.break_delay || 0,
						hmc_remind: knowledge.hmc_remind || false,
						hmc_skill_id: knowledge.hmc_skill_id || '',
						hmc_after_play: knowledge.hmc_after_play || false,
						rate: knowledge.rate || 0,
						vars: knowledge.vars || [],
					}
				}

				return syncKnowledge;
			});
		},
		/**
		 * 
		 * @param existingSceneJson 要修改的话术
		 * @param syncKnowledges 要同步的知识库
		 * @param duplicateHandle 同步的重复处理方式
		 * @param keywordHandle 同步的关键词处理方式
		 * @param syncContent 同步的内容类型
		 */ 
		mergeKnowledge(existingSceneJson, syncKnowledges, duplicateHandle, keywordHandle, syncContent) {
			const sceneJson = cloneDeep(existingSceneJson);
			const result = sceneJson.knowledge || []
			const existingMap = new Map();
			// 建立现有知识库的映射（按name）同时获取到最大的知识库id
			let maxKnowledgeId = 0;
			result.forEach(knowledge => {
				const idNum = parseInt(knowledge.id.replace('K', ''));
				if (!isNaN(idNum) && idNum > maxKnowledgeId) {
					maxKnowledgeId = idNum;
				}
				existingMap.set(knowledge.name, knowledge);
			});
			// 处理录音id
			let maxVoiceId = 0;
			const getMaxVoiceId = (obj) => {
				for (let key in obj) {
					if (key === 'id' && typeof obj[key] === 'string') {
						const idNum = parseInt(obj[key].replace('V', ''));
						if (!isNaN(idNum) && idNum > maxVoiceId) {
							maxVoiceId = idNum;
						}
					} else if (typeof obj[key] === 'object' && obj[key] !== null) {
						getMaxVoiceId(obj[key]);
					}
				}
			}
			getMaxVoiceId(sceneJson)
			const getNewId = (key) => {
				// 递增ID并格式化为5位数字
				let nextId = ++maxKnowledgeId;
				if (key === 'V') {
					nextId = ++maxVoiceId;
				}
				return `${key}${nextId.toString().padStart(5, '0')}`;
			}
			// 处理自定义变量
			// 1.获取要同步的数据里面涉及到的所有变量
			const addVars = new Set();
			syncKnowledges.forEach(syncKnowledge => {
				const { vars: knowledgeVars = [] } = syncKnowledge;
				knowledgeVars.forEach(varItem => {
					addVars.add(varItem.name);
				});
			});
			// 2.将变量添加到话术中
			[...addVars].forEach(varName => {
				const sceneVars = sceneJson.settings?.vars || [];
				if (!sceneVars.find(item => item.name === varName))  {
					const addVar = this.vars.find(item => item.name === varName)
					sceneJson.settings.vars.push(addVar)
				}
			})


			syncKnowledges.forEach(syncKnowledge => {
				const {name, sentences = [], ref_id, ...otherParams} = syncKnowledge;
				let existingKnowledge = existingMap.get(name);

				if (existingKnowledge) {
					// 重复处理：覆盖
					if (duplicateHandle === 'cover') {
						// 关键词处理
						if (keywordHandle === 'cover' && syncContent.includes('2')) {
							// 覆盖关键词
							existingKnowledge.sentences = sentences || [];
							existingKnowledge.ref_id = ref_id;
						} else if (keywordHandle === 'append' && syncContent.includes('2')) {
							// 补充关键词（去重）
							const existingSentences = existingKnowledge.sentences || [];
							existingKnowledge.sentences = [...new Set([...existingSentences, ...sentences])];
							existingKnowledge.ref_id = existingKnowledge.ref_id || ref_id;
						}
						// 更新其他字段
						if (syncContent.includes('1')) existingKnowledge.name = name;
						if (syncContent.includes('3')) {
							Object.assign(existingKnowledge, otherParams, {
								type: syncKnowledge.type || '',
								conditions: syncKnowledge.conditions || [],
								responses: syncKnowledge.responses?.map(response => ({
									...response,
									id: getNewId('V'),
								})) || [],
								action: syncKnowledge.action || '',
								action_data: syncKnowledge.action_data || '',
								tag: syncKnowledge.tag || '',
								can_break: syncKnowledge.can_break || false,
								break_delay: syncKnowledge.break_delay || 0,
								hmc_remind: syncKnowledge.hmc_remind || false,
								hmc_skill_id: syncKnowledge.hmc_skill_id || '',
								hmc_after_play: syncKnowledge.hmc_after_play || false,
								rate: syncKnowledge.rate || 0,
								vars: syncKnowledge.vars || [],
							});
						}
					}
				} else {
					// 新意图，添加到结果中
					const newKnowledge = {
						id: getNewId('K'),
						type: syncKnowledge.type || '',
						name: syncKnowledge.name || '',
						sentences: syncKnowledge.sentences || [],
						conditions: syncKnowledge.conditions || [],
						responses: syncKnowledge.responses?.map(response => ({
							...response,
							id: getNewId('V'),
						})) || [],
						action: syncKnowledge.action || '',
						action_data: syncKnowledge.action_data || '',
						tag: syncKnowledge.tag || '',
						can_break: syncKnowledge.can_break || false,
						break_delay: syncKnowledge.break_delay || 0,
						hmc_remind: syncKnowledge.hmc_remind || false,
						hmc_skill_id: syncKnowledge.hmc_skill_id || '',
						hmc_after_play: syncKnowledge.hmc_after_play || false,
						rate: syncKnowledge.rate || 0,
						vars: syncKnowledge.vars || [],
						ref_id: syncKnowledge.ref_id || '',
						is_ref_priority: syncKnowledge.is_ref_priority || true,
					};

					result.push(newKnowledge);
				}
			});

			return [result, sceneJson.settings.vars];
		},
		handleSelectionChange(selection) {
			this.selectedKnowledge = selection;
		},
	}
}
</script>
<style lang="scss" scoped>
.container {
	width: 100%;
	padding: 20px;
	background-color: #fff;

	.handle-container {
		width: 100%;
		display: flex;
		justify-content: space-between;

		.btn-style {
			display: flex;
			justify-items: flex-start;

			div {
				padding: 10px 20px;
				border-radius: 20px;
				font-size: 14px;
				color: #fff;
			}

			i {
				font-size: 18px;
			}
		}
	}

	.table-container {
		padding: 20px 0;
	}

	.del-style {
		color: #e72e2e;
		cursor: pointer;
	}

	.edit-style {
		display: inline-block;
		color: #6186cf;
		padding-right: 20px;
		cursor: pointer;
	}

	.import-btn {
		margin-left: 15px;
	}

	.keywordCon {
		max-height: 200px;
		overflow-y: auto;
	}
	.hit-percent {
		color: #ff9c00;
		font-weight: 600;
	}
}
</style>